import styled from 'styled-components';

export const DivWrap = styled.div`
  padding: .5rem 0;
	align-items: flex-start;
	display: flex;
	@media (max-width: 440px){
		padding: .25rem 0 0;
	}
	gap: 8px;
	@media (min-width: 981px) and (max-width:1069px){
		padding: 2px 0;
	}
`;

export const DivLabel = styled.div`
	    display: flex;
			flex-direction: column;
    	align-items: flex-start;
    	gap: 3px;
			
			margin-bottom: 0;

			span{
				display:inline-flex;
				svg{
					width: 18px;
					height: 18px;
				}
			}

			label{
				color: var(--textColor);
				font-family: Inter;
				font-size: 13px;
				font-weight: 500;
			}

			@media (max-width: 1339px){
			 	svg{ width: 18px; height: 18px}
			}

			// &.roof-attr-label{
			// 	font-weight: 400;
			// }
`;
export const DivValue = styled.div`
			display: flex;
    	align-items: center;
    	gap: 5px;
			font-family: Inter;
			// color:rgb(46, 56, 77);
    	font-size: 13px;
			line-height:16px;
    	font-weight: 600;
			color: var(--primary);

			@media (max-width: 1339px){
			 svg{ width: 18px; height: 18px}
			}

			&.roof-attr-value{
				color: var(--primary);
				font-size: 1.125rem;
    		font-weight: 600;
			}
`;